import React from "react";
import { AttachmentThumb } from "./AttachmentsStep";
import { isVisible } from "./QuestionField";

export const budgetLabel = (r) =>
  r.budget_type === "open" ? "Open to quotes" : r.budget_type === "hourly" ? `$${r.budget_hourly ?? "?"}/hr` : `$${(r.budget_min ?? 0).toLocaleString()} – $${(r.budget_max ?? 0).toLocaleString()}`;

const Row = ({ label, value }) => (
  <div className="flex items-baseline justify-between gap-6 py-2 border-b border-slate-100 last:border-0">
    <span className="text-xs text-[#252A34]/60">{label}</span>
    <span className="text-sm text-[#071b22] font-medium text-right">{Array.isArray(value) ? value.join(", ") : String(value)}</span>
  </div>
);

export default function ReviewStep({ req, set, onJump }) {
  const answers = req.answers || {};
  const sections = req.questionnaire_snapshot?.sections || [];
  return (
    <div className="space-y-6" data-testid="review-step">
      <div className="font-display text-xl font-semibold text-[#071b22]">Review your request</div>
      <label className="block">
        <div className="text-sm font-semibold text-[#071b22] mb-2">Anything else pros should know?</div>
        <textarea rows={4} value={req.description || ""} onChange={(e) => set("description", e.target.value)} className="sr-input" placeholder="Access notes, deal-breakers, what's already been tried…" data-testid="review-description" />
      </label>
      {sections.map((s, i) => (
        <div key={s.title} className="rounded-2xl border border-slate-200 p-4">
          <div className="flex items-center justify-between mb-1">
            <div className="text-xs font-bold uppercase tracking-[0.16em] text-[#165a71]">{s.title}</div>
            <button onClick={() => onJump(i)} className="text-xs text-[#165a71] underline" data-testid={`review-edit-${i}`}>Edit</button>
          </div>
          {s.questions.filter((q) => isVisible(q, answers) && answers[q.id] != null && answers[q.id] !== "" && !(Array.isArray(answers[q.id]) && !answers[q.id].length)).map((q) => <Row key={q.id} label={q.label} value={answers[q.id]} />)}
        </div>
      ))}
      <div className="rounded-2xl border border-slate-200 p-4">
        <Row label="Timing" value={(req.urgency || "—").replace(/_/g, " ")} />
        {req.address_snapshot?.city && <Row label="Location" value={`${req.address_snapshot.city}, ${req.address_snapshot.state || ""} ${req.address_snapshot.zip_code || ""}`} />}
        <Row label="Budget" value={budgetLabel(req)} />
      </div>
      {(req.attachments || []).length > 0 && (
        <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">{req.attachments.map((a) => <AttachmentThumb key={a.id} a={a} />)}</div>
      )}
      <div className="rounded-xl bg-[#165a71]/[0.06] border border-[#165a71]/20 p-3 text-xs text-[#071b22]">
        Your street address and contact details stay private. Matched pros see the city, your answers and photos, and send estimates you can compare.
      </div>
    </div>
  );
}
